module.exports = __webpack_public_path__ + "img/transfer.a6c82ed6.svg";